import React, { Dispatch, SetStateAction } from 'react';
import {
  StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import Colors from '../constants/Colors';
import NewSwitch from './NewSwitch';

type Props = {
  title: string;
  subTitle?: string;
  toggled: boolean;
  toggle: Dispatch<SetStateAction<boolean>>,
  testID?: string,
};

const NotificationSettingRow = ({
  title, subTitle, toggled, toggle, testID,
}: Props) => <View style={styles.container}>
    <View>
      <Text style={styles.title}>{title}</Text>
      {subTitle && <Text style={styles.subTitle}>{subTitle}</Text>}
    </View>
    <TouchableOpacity
      onPress={() => toggle(!toggled)}
      style={{ position: 'absolute', right: 16 }}
      {...{ testID }}
    >
      <NewSwitch
        isToggled={toggled}
        color={Colors.light.hereworksGreen400}
        style={{}}
      />
    </TouchableOpacity>
  </View>;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Colors.light.hereworksWhite100,
    alignSelf: 'stretch',
    padding: 16,
    borderRadius: 10,
    marginBottom: 8,
  },
  title: {
    fontSize: 18,
    lineHeight: 27,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
  subTitle: {
    fontSize: 16,
    lineHeight: 22,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack400,
  },
});

export default NotificationSettingRow;
